import { render } from "./WithdrawDeposit.vue?vue&type=template&id=47755802&scoped=true"
import script from "./WithdrawDeposit.vue?vue&type=script&lang=js"
export * from "./WithdrawDeposit.vue?vue&type=script&lang=js"

import "./WithdrawDeposit.vue?vue&type=style&index=0&id=47755802&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47755802"]])

export default __exports__